import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { requestPasswordReset } from '../../services/AuthService';
import logger from '../../utils/logger';

function ForgotPassword() {

    const [email, setEmail] = useState('');
    const [sent, setSent] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    function onSubmit(event) {
        event.preventDefault();
        setLoading(true);
        setError('');
        requestPasswordReset(email)
            .then(() => {
                setSent(true);
                setLoading(false);
            })
            .catch(err => {
                logger.error(err);
                // Backend always answers 200; only network errors reach here.
                setError('Something went wrong. Please try again later.');
                setLoading(false);
            });
    }

    return (
        <main>
            <section className="vh-lg-100 mt-5 mt-lg-0 bg-soft d-flex align-items-center">
                <div className="container">
                    <p className="text-center">
                        <Link to="/" className="d-flex align-items-center justify-content-center">
                            <svg className="icon icon-xs me-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z" clipRule="evenodd"></path>
                            </svg>
                            Back to sign in
                        </Link>
                    </p>
                    <div className="col-12 d-flex align-items-center justify-content-center">
                        <div className="bg-white shadow border-0 rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                            <div className="text-center">
                                <img src="/img/favicon/mstile-150x150.png" alt="AutoCryptoBot" width={64} />
                            </div>
                            <div className="text-center text-md-center mb-4 mt-md-0">
                                <h1 className="mb-0 h3">Reset your password</h1>
                                <p className="text-gray-600 mt-2 mb-0">
                                    Enter your e-mail and we'll send you a new password.
                                </p>
                            </div>

                            {sent ? (
                                <div className="alert alert-success mt-3" role="alert">
                                    If an account exists for <strong>{email}</strong>, a new password has been sent to that e-mail.
                                    Please check your inbox (and spam folder).
                                    <div className="d-grid mt-3">
                                        <Link to="/" className="btn btn-gray-800">Back to sign in</Link>
                                    </div>
                                </div>
                            ) : (
                                <form action="#" className="mt-4" onSubmit={onSubmit}>
                                    <div className="form-group mb-4">
                                        <label htmlFor="email">Your Email</label>
                                        <div className="input-group">
                                            <span className="input-group-text" id="basic-addon1">
                                                <svg className="icon icon-xs text-gray-600" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"></path><path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"></path></svg>
                                            </span>
                                            <input type="email" className="form-control" placeholder="example@company.com" id="email" autoFocus required value={email} onChange={e => setEmail(e.target.value)} />
                                        </div>
                                    </div>
                                    <div className="d-grid">
                                        <button type="submit" className="btn btn-gray-800" disabled={loading}>
                                            {loading ? 'Sending…' : 'Send new password'}
                                        </button>
                                    </div>
                                    {error ? <div className="alert alert-danger mt-2">{error}</div> : null}
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
}

export default ForgotPassword;
